import { render } from "./LineChartO.vue?vue&type=template&id=04b801eb&scoped=true"
import script from "./LineChartO.vue?vue&type=script&lang=ts"
export * from "./LineChartO.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-04b801eb"

export default script